import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GerinusService } from '../lib/gerinus.service';

@Injectable()
export class EvaluationTermService extends GerinusService {
    constructor(public http: HttpClient) {
        super(http);
        this.entityName = 'triagem_termo';
        this.idField = 'TT_CodigoTriagemTermo';
        this.model = 'TriagemTermoModel';
    }
}
